import { Box, Button, ButtonGroup, Heading, Modal, Table, TextButton } from '@zillow/constellation-10';
import type { MissingItem } from './OverviewReportSidebar';
import { useMainLayout } from '../../../layouts/MainPageLayout/MainLayoutContext';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { emitOverviewListingQualityViewListingEvent } from '../../../../analytics/events';

export const MissingAttributesModal = ({
  isOpen,
  onClose,
  missingItem,
}: {
  isOpen: boolean;
  onClose: () => void;
  missingItem: MissingItem | null;
}) => {
  const { filteredProperties } = useMainLayout();
  const { user } = useRentalManagerUser();

  const listingAliases = [...new Set(missingItem?.properties.map((property) => property.listingAlias))];

  const selectedProperties = filteredProperties.filter((property) =>
    listingAliases.some((listingAlias) => property.aggregateStats.listingAliases.includes(listingAlias)),
  );

  return (
    <Modal
      open={isOpen}
      body={
        <Table.Root
          aria-label="Properties missing table"
          css={{ tableLayout: 'auto', border: '1px solid', borderColor: 'Table.Cell.border', borderBottom: 'none' }}
          appearance="horizontal"
        >
          <Table.Body css={{ borderRadius: '300', overflow: 'visible' }}>
            {selectedProperties.map((property) => (
              <Table.Row key={property.propertyDetails.listingAlias}>
                <Table.Cell>{property.propertyDetails.listingName}</Table.Cell>
                <Table.Cell>{`${property.propertyDetails.street}, ${property.propertyDetails.city}, ${property.propertyDetails.state} ${property.propertyDetails.zip}`}</Table.Cell>
                <Table.Cell>
                  <Box css={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      asChild
                      css={{ whiteSpace: 'nowrap' }}
                      onClick={() => {
                        if (user) emitOverviewListingQualityViewListingEvent({ user });
                      }}
                    >
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={`/rental-manager/properties/${property.aggregateStats.currentListingAlias}/listing`}
                      >
                        Edit listing
                      </a>
                    </Button>
                  </Box>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      }
      dividers
      footer={
        <ButtonGroup aria-label="modal actions">
          <TextButton asChild>
            <a target="_blank" rel="noreferrer" href={'/rental-manager/properties'}>
              View all properties
            </a>
          </TextButton>
        </ButtonGroup>
      }
      header={<Heading level={1}>{missingItem?.modalHeader}</Heading>}
      onOpenChange={onClose}
      shouldAwaitInteractionResponse
      size="md"
    />
  );
};
